module.exports = __webpack_public_path__ + "img/main-ball-orange-line.1c7fcc0d.png";